export default __webpack_public_path__ + "static/media/Alexandre.6b135b63.webp";